export default {"src":"/_next/static/media/Advantage.7c049a15.svg","height":14,"width":81};